var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignHorizontalLeft = function SvgAlignHorizontalLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "matrix(-1 0 0 1 16 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 8,
    rx: 0.667,
    transform: "matrix(0 1 1 0 2.667 4.667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 5.333,
    rx: 0.667,
    transform: "matrix(0 1 1 0 5.333 8.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.333V2.667a.667.667 0 0 1 1.333 0v10.666a.667.667 0 1 1-1.333 0"
  }))));
};
export default SvgAlignHorizontalLeft;